module.exports = __webpack_public_path__ + "static/media/circle-2.03348e94.png";